import React from "react";
import { useTranslation } from 'contexts/Localization'
import {
  Flex,
  Link,
  MetamaskIcon,
  Text,
  darkColors,
  LogoWithTextIcon,
  TwitterIcon,
  MediumIcon,
  TelegramIcon,
  Button
} from "@pancakeswap/uikit";
import { registerToken } from 'utils/wallet'
import { useWeb3React } from "@web3-react/core";
import { serializeTokens } from 'config/constants/tokens'
import useParsedQueryString from "hooks/useParsedQueryString";
import { footerLinks } from "./config"
import {
  StyledFooter,
  StyledList,
  StyledListItem
} from "./styles"

import { FooterProps } from "./types";

const MenuItem: React.FC<FooterProps> = ({
  isDark,
  ...props
}) => {
  const { account } = useWeb3React()
  const { t } = useTranslation()

  const parsedQs = useParsedQueryString()
  const campaignId = (typeof parsedQs.utm_id === 'string') ? parsedQs.utm_id : ''
  const serializedTokens = serializeTokens()
  const isMetaMaskInScope = !!window.ethereum?.isMetaMask
  const allowAirdrop = process.env.REACT_APP_ALLOW_AIRDROP

  return (
    <StyledFooter p={["40px 16px", null, "56px 40px 32px 40px"]} {...props} justifyContent="center" id="page-foot">
      <Flex flexDirection="column" width={["100%", null, "1200px;"]}>
        <Flex
          alignItems="flex-start"
          mb={["42px", null, "36px"]}
          flexDirection={["column", null, "row"]}
        >
          <div className="logo-wrap">
            <LogoWithTextIcon isDark width={66} fontSize="36" />
            <Flex className="email-wrap">
              <Link
                className="link"
                href="mailto:info@deblox.io"
                target="_blank"
                rel="noreferrer noopener"
                color="#00C2FF"
                bold={false}
              >info@deblox.io</Link>
            </Flex>
          </div>
          <div className="link-wrap">
            {footerLinks(t)?.map((item) => (
              <StyledList key={item.label}>
                <StyledListItem>{item.label}</StyledListItem>
                {item.items?.map(({ label, href }) => (
                  <StyledListItem key={label}>
                    <Link
                      href={href}
                      target="_blank"
                      rel="noreferrer noopener"
                      color="#"
                      bold={false}
                    >
                      {label}
                    </Link>
                  </StyledListItem>
                ))}
              </StyledList>
            ))}
          </div>
          <StyledList className="right">
            <StyledListItem>
              {allowAirdrop && account && isMetaMaskInScope && (
                <Button
                  variant="text"
                  width="120px"
                  height="28px"
                  style={{padding: 0}}
                  onClick={() => registerToken(serializedTokens.dgs.address, serializedTokens.dgs.symbol, serializedTokens.dgs.decimals)}
                >
                  <Flex alignItems="center">
                    <MetamaskIcon mr="16px" width="28" />
                    <Text color="#00C2FF" fontSize="11px" fontStyle="italic" lineHeight="13px" textAlign="left">
                      {t('  Add DGS to Metamask')}
                    </Text>
                  </Flex>
                </Button>
              )}
            </StyledListItem>
            <StyledList className="m0">
              <StyledListItem>{t('Community')}</StyledListItem>
              <StyledListItem>
                <Link
                  className="link"
                  href="https://discord.gg/GcVu3Ekkmd"
                  target="_blank"
                  rel="noreferrer noopener"
                  color={darkColors.text}
                  bold={false}
                  width="24px"
                  mr="10px"
                >
                  <img style={{ width: '23px' }} src="/images/icons/blue/discord.png" alt="Discord" />
                </Link>
                <Link
                  className="link"
                  href={campaignId.length > 0 ? `https://t.me/deblox/?start=${campaignId}` : "https://t.me/deblox"}
                  target="_blank"
                  rel="noreferrer noopener"
                  color={darkColors.text}
                  bold={false}
                  width="24px"
                  mr="10px"
                >
                  <img style={{ width: '23px' }} src="/images/icons/blue/telegram.png" alt="Telegram" />
                </Link>
                <Link
                  className="link"
                  href="https://twitter.com/debloxio"
                  target="_blank"
                  rel="noreferrer noopener"
                  color={darkColors.text}
                  bold={false}
                  width="24px"
                  mr="10px"
                >
                  <img style={{ width: '23px' }} src="/images/icons/blue/twitter.png" alt="Twitter" />
                </Link>
                <Link
                  className="link"
                  href="https://medium.com/@Deblox"
                  target="_blank"
                  rel="noreferrer noopener"
                  color={darkColors.text}
                  bold={false}
                  width="24px"
                >
                  <img style={{ width: '23px' }} src="/images/icons/blue/medium.png" alt="Medium" />
                </Link>
              </StyledListItem>
            </StyledList>
            <StyledList className="m0">
              <StyledListItem>© 2022 Deblox. All rights reserved.</StyledListItem>
              <Link
                className="mobile-email"
                href="mailto:info@deblox.io"
                target="_blank"
                rel="noreferrer noopener"
                color="#00C2FF"
                bold={false}
              >info@deblox.io</Link>
            </StyledList>
          </StyledList>
        </Flex>
      </Flex>
    </StyledFooter>
  );
};

export default MenuItem;
